const nonNegative = (value) => Math.max(0, Number(value) || 0);

export const getReadyToInvoiceProgress = (row = {}) => {
  const expected = nonNegative(row.estimatedInvoiceAmount);
  const invoiceAmount = nonNegative(row.totalInvoiceAmount);
  const invoiced = Math.min(expected, invoiceAmount);
  const paid = Math.min(invoiced, nonNegative(row.totalPaidAmount));
  const remaining = nonNegative(row.uninvoicedAmount ?? (expected - invoiced));
  const progress = expected > 0
    ? Math.min(100, Math.max(0, (invoiced / expected) * 100))
    : 0;

  return {
    expected,
    invoiced,
    paid,
    remaining,
    progress,
    hasInvoice: invoiceAmount > 0,
    hasPayment: paid > 0,
  };
};
